export const getColorProfileSize = (
  percentage: number,
  index: number,
  scale = 1
) => {
  if (index === 0) return 150 * scale;
  if (index === 4) return 50 * scale;

  const size = percentage * 5;

  if (size >= 120) return 120 * scale;
  if (size <= 70) return 70 * scale;

  return size * scale;
};
